import React from "react";
import IconGlyph from "@/bit/components/components.icon-glyph";
import getColor from "@gcloud-npm/utils.enums.colors";
import TextCard from "../../text-card";
import ImageCard from "../../image-card";

const GridLayout = (props) => {
  const { direction, cmsHandler, hideShadow } = props;
  const backgroundColor = props?.backgroundColor || "WHITE";
  const gridSmallIndex = [1, 2];
  const title = props["cms-atom-text-1"];
  const description = props["cms-atom-text-2"];
  const linkText = props["cms-atom-text-3"];
  const link = props["cms-atom-link-1"];
  const cards = props["cms-component-image-list-1"];

  return (
    <div
      className="module-container"
      style={{ backgroundColor: getColor(backgroundColor) }}
    >
      <div className="container">
        {cmsHandler && (
          <span
            className={"element-editable block edit-component"}
            onClick={() =>
              cmsHandler({
                ...props,
                name: "cms-block.cms-image-cluster",
              })
            }
          >
            <IconGlyph id="lapiz-m" height={20} color="white" />
          </span>
        )}
        <div className="row grid-layout" data-cy="Grid Layout">
          <div
            className="col-xs-12 col-sm-12 col-md-3 text-card"
            data-cy="Text Card"
          >
            <TextCard
              cmsHandler={cmsHandler}
              title={title}
              description={description}
              link={link}
              linkText={linkText}
            />
          </div>

          <div
            className={`col-xs-12 col-sm-12 col-md-9 image-cards image-cards--${direction}`}
            data-cy="Image Cards"
          >
            {cards &&
              cards.map((card, i) => (
                <ImageCard
                  {...card}
                  cmsHandler={cmsHandler}
                  isSmall={gridSmallIndex.includes(i)}
                  hideShadow={hideShadow === true || hideShadow === "true"}
                  key={`card-${i}`}
                />
              ))}
          </div>

          <div></div>
        </div>
      </div>
    </div>
  );
};

export default GridLayout;

GridLayout.defaultProps = {
  backgroundColor: "WHITE",
};
